module.exports = __webpack_public_path__ + "img/1.e02c4d5d.svg";